import React from 'react';
import PropTypes from 'prop-types';

import MessagePresenter from '../../../../../../presenters/MessagePresenter';
import OneLineSkeleton from '../../../../../../components/Skeletons/OneLineSkeleton';
import { ONE_LINE_SKELETON_WIDTH } from '../../../../../../pages/constants';
import Label from '../../../../../../components/Label';
import Select from '../../../../../../components/Select';

const MessageSelect = (props) => {
  const { value, messages, onChange, isFulfilled, errors, required } = props;

  const options = messages.map((message) => {
    return {
      value: MessagePresenter.id(message),
      label: MessagePresenter.title(message),
    };
  });

  const defaultOption = { value: '', label: '-- Select Message --' };

  return (
    <div>
      <Label name="messageId" title="Message to send" errors={errors} />
      {!isFulfilled && <OneLineSkeleton width={ONE_LINE_SKELETON_WIDTH} />}
      {isFulfilled && (
        <Select
          id="messageId"
          options={options}
          value={value}
          onChange={onChange}
          defaultOption={defaultOption}
          required={required}
        />
      )}
    </div>
  );
};

export default MessageSelect;

MessageSelect.propTypes = {
  value: PropTypes.string,
  messages: PropTypes.arrayOf(MessagePresenter.shape()),
  onChange: PropTypes.func.isRequired,
  isFulfilled: PropTypes.bool.isRequired,
  errors: PropTypes.shape(),
  required: PropTypes.bool,
};

MessageSelect.defaultProps = {
  value: '',
  errors: {},
  messages: [],
  required: true,
};
